(function (){
    'use strict';

    angular
        .module('services')
        .service('PhysicalFairService', PhysicalFairService);

    PhysicalFairService.$inject = ['$http', 'API_BASE'];

    function PhysicalFairService ($http, API_BASE) {
        var service = this;

        service.getByFilterStudentsAnalytic                 = getByFilterStudentsAnalytic;
        service.getByFilterStudents                         = getByFilterStudents;
        service.getGenderOfStudents                         = getGenderOfStudents;
        service.getIsParentOfStudents                       = getIsParentOfStudents;
        service.getAgeOfStudents                            = getAgeOfStudents;
        service.getHowPlanningOfStudents                    = getHowPlanningOfStudents;
        service.getByFilterExpositors                       = getByFilterExpositors;
        service.getExpositorsByType                         = getExpositorsByType;
        service.getExpositorsByCountry                      = getExpositorsByCountry;
        service.getByFilterExhibitorsByExpo                 = getByFilterExhibitorsByExpo;
        service.downloadReportExhibitorByExpoCSV            = downloadReportExhibitorByExpoCSV;
        service.getByFilterPreApproved                      = getByFilterPreApproved;
        service.getByFilterUncompletedRegistrations         = getByFilterUncompletedRegistrations;
        service.updatePreApproved                           = updatePreApproved;
        service.downloadReportUncompletedRegistrationsCSV   = downloadReportUncompletedRegistrationsCSV;
        service.getByFilterSeminars                         = getByFilterSeminars;
        service.downloadReportSeminarsCSV                   = downloadReportSeminarsCSV;
        service.getByFilterGoals                            = getByFilterGoals;
        service.getSellers                                  = getSellers;
        service.getExpos                                    = getExpos;
        service.saveGoal                                    = saveGoal;
        service.getByFilterComments                         = getByFilterComments;
        service.downloadReportCommentsCSV                   = downloadReportCommentsCSV;
        service.getByFilterGoalsDashboard                   = getByFilterGoalsDashboard;
        service.getByFilterExhibitorsDescriptions           = getByFilterExhibitorsDescriptions;
        service.downloadReportExhibitorsDescriptionsCSV     = downloadReportExhibitorsDescriptionsCSV;
        service.getByTotalStudents                          = getByTotalStudents;
        service.getByFilterBadges                           = getByFilterBadges;
        service.downloadReportBadgesCSV                     = downloadReportBadgesCSV;
        service.getByFilterFasciaName                       = getByFilterFasciaName;
        service.downloadReportFasciaNameCSV                 = downloadReportFasciaNameCSV;
        service.getByFilterPublicRelationsTexts             = getByFilterPublicRelationsTexts;
        service.downloadPublicRelationsTextsCSV             = downloadPublicRelationsTextsCSV;
        service.getByFilterExpoLocation                     = getByFilterExpoLocation;
        service.downloadWelcomeLetter                       = downloadWelcomeLetter;
        service.getRepresentativesByExpo                    = getRepresentativesByExpo;
        service.getAcceptedInvoices                         = getAcceptedInvoices;
        service.getFlightsRequests                          = getFlightsRequests;
        service.getFlightsRequestsCSV                       = getFlightsRequestsCSV;
        service.getEmailExhibitorsLocations                 = getEmailExhibitorsLocations;
        service.getExhibitorsFromExpoLocationId             = getExhibitorsFromExpoLocationId;
        service.updateExhibitorsSelected                    = updateExhibitorsSelected;
        service.getExhibitorsFromExpoId                     = getExhibitorsFromExpoId;
        service.getAllExhibitorsFromExpoLocationId          = getAllExhibitorsFromExpoLocationId;
        service.getByFilterBoothTableBooked                 = getByFilterBoothTableBooked;
        service.getByFilterBoothTableBookedCSV              = getByFilterBoothTableBookedCSV;
        service.getByFilterStudentsRegistrations            = getByFilterStudentsRegistrations;
        service.getExhibitorsRegistrationComparative        = getExhibitorsRegistrationComparative;
        service.getStudentsPhones                           = getStudentsPhones;
        service.getStudentsPhonesCsv                        = getStudentsPhonesCsv;
        service.getStudentsEmails                           = getStudentsEmails;
        service.getStudentsEmailsCsv                        = getStudentsEmailsCsv;
        service.getNetworkingCounselors                     = getNetworkingCounselors;
        service.getNetworkingCounselorsCsv                  = getNetworkingCounselorsCsv;
        service.getByFilterPreRegistrations                 = getByFilterPreRegistrations;
        service.getAllSellers                               = getAllSellers;
        service.getByFilterExpenses                         = getByFilterExpenses;
        service.storeExpense                                = storeExpense;
        service.getExpense                                  = getExpense;
        service.updateExpense                               = updateExpense;
        service.destroyExpense                              = destroyExpense;
        service.getSponsors                                 = getSponsors;
        service.getBoothTypes                               = getBoothTypes;
        service.getSideEvents                               = getSideEvents;
        service.getStudentsEnrolled                         = getStudentsEnrolled;
        service.getStudentsEnrolledCsv                      = getStudentsEnrolledCsv;
        service.sendInviteToStudentsEnrolled                = sendInviteToStudentsEnrolled;
        service.getSurveys                                  = getSurveys;
        service.getSurveyQuestions                          = getSurveyQuestions;
        service.copySurvey                                  = copySurvey;
        service.downloadCSVExpo                             = downloadCSVExpo;
        service.downloadCSVVirtualFair                      = downloadCSVVirtualFair;
        service.getCommunitiesCollege                       = getCommunitiesCollege;
        service.leadsCSV                                    = leadsCSV;
        service.getTranslators                              = getTranslators;
        service.getLeadsBooth                               = getLeadsBooth;
        service.getLeadsBoothCsv                            = getLeadsBoothCsv;
        service.sendEmailTest                               = sendEmailTest;
        service.getPrograms                                 = getPrograms;
        service.getPrizes                                   = getPrizes;
        service.getReferrals                                = getReferrals;
        service.getWinners                                  = getWinners;
        service.generateWinners                             = generateWinners;
        service.saveWinners                                 = saveWinners;


        /* STUDENTS */
        function getByFilterStudentsAnalytic(query) {
            return $http.get(API_BASE + '/physicalfairs/students/analytic', {params: query});
        }

        function getByFilterStudents(query) {
            return $http.get(API_BASE + '/physicalfairs/students/', {params: query});
        }

        function getGenderOfStudents(query) {
            return $http.get(API_BASE + '/physicalfairs/students/graph/gender', {params: query});
        }

        function getIsParentOfStudents(query) {
            return $http.get(API_BASE + '/physicalfairs/students/graph/isparent', {params: query});
        }

        function getAgeOfStudents(query) {
            return $http.get(API_BASE + '/physicalfairs/students/graph/age', {params: query});
        }

        function getHowPlanningOfStudents(query) {
            return $http.get(API_BASE + '/physicalfairs/students/graph/howplanning', {params: query});
        }

        /* EXHIBITORS */
        function getByFilterExpositors(query) {
            return $http.get(API_BASE + '/physicalfairs/expositors/', {params: query});
        }

        function getExpositorsByType(query) {
            return $http.get(API_BASE + '/physicalfairs/expositors/graph/type/', {params: query});
        }

        function getExpositorsByCountry(query) {
            return $http.get(API_BASE + '/physicalfairs/expositors/graph/country/', {params: query});
        }

        function getByFilterExhibitorsByExpo(query) {
            return $http.get(API_BASE + '/physicalfairs/reports/exhibitors/expo', {params: query});
        }

        function downloadReportExhibitorByExpoCSV(query) {
            return $http.get(API_BASE + '/physicalfairs/reports/exhibitors/expo/csv', {params: query});
        }

        /* PRE-APPROVED */
        function getByFilterPreApproved(query) {
            return $http.get(API_BASE + '/physicalfairs/preapproved/', {params: query});
        }

        function updatePreApproved(query) {
            return $http.get(API_BASE + '/physicalfairs/preapproved/update', {params: query});
        }

        /* UNCOMPLETED-REGISTRATIONS */
        function getByFilterUncompletedRegistrations(query) {
            return $http.get(API_BASE + '/physicalfairs/uncompletedregistrations/', {params: query});
        }

        function downloadReportUncompletedRegistrationsCSV(query) {
            return $http.get(API_BASE + '/physicalfairs/reports/uncompleted/registrations/csv', {params: query});
        }

        /* SEMINARS */
        function getByFilterSeminars(query) {
            return $http.get(API_BASE + '/physicalfairs/seminars/', {params: query});
        }

        function downloadReportSeminarsCSV(query) {
            return $http.get(API_BASE + '/physicalfairs/reports/seminars/csv', {params: query});
        }

        /* GOALS */
        function getByFilterGoals(query) {
            return $http.get(API_BASE + '/physicalfairs/goals', {params: query});
        }

        function getSellers(query) {
            return $http.get(API_BASE + '/sellers/list', {params: query});
        }

        function getAllSellers(query) {
            return $http.get(API_BASE + '/expos/sellers/list', {params: query});
        }

        function getExpos(query) {
            if (query['platform-rental'] != undefined) {
                return $http.get(API_BASE + '/platform-rental/physicalfairs', {params: query});
            } else {
                return $http.get(API_BASE + '/physicalfairs/goals/expos', {params: query});
            }
        }



        function saveGoal(query) {
            return $http.get(API_BASE + '/physicalfairs/goals/save', {params: query});
        }

        /* COMMENTS */
        function getByFilterComments(query) {
            return $http.get(API_BASE + '/physicalfairs/comments/', {params: query});
        }

        function downloadReportCommentsCSV(query) {
            return $http.get(API_BASE + '/physicalfairs/reports/comments/csv', {params: query});
        }

        /* DASHBOARD */
        function getByFilterGoalsDashboard (query) {
            return $http.get(API_BASE + '/dashboard',{params:query});
        }

        /* Exhibitors Descriptions */
        function getByFilterExhibitorsDescriptions (query) {
            return $http.get(API_BASE + '/physicalfairs/exhibitors/descriptions',{params:query});
        }

        function downloadReportExhibitorsDescriptionsCSV (query) {
            return $http.get(API_BASE + '/physicalfairs/exhibitors/descriptions/csv',{params:query});

        }
        function getByTotalStudents(query) {
            return $http.get(API_BASE + '/physicalfairs/getStudentsTotal', {params:query});
        }
        /* BADGES */
        function getByFilterBadges (query) {
            return $http.get(API_BASE + '/physicalfairs/badges',{params:query});
        }

        function downloadReportBadgesCSV (query) {
            return $http.get(API_BASE + '/physicalfairs/badges/csv',{params:query});
        }

        /* FASCIA NAME */

        function getByFilterFasciaName (query) {
            return $http.get(API_BASE + '/physicalfairs/fascianame',{params:query});
        }

        function downloadReportFasciaNameCSV (query) {
            return $http.get(API_BASE + '/physicalfairs/fascianame/csv',{params:query});
        }

        /* PUBLIC RELATIONS TEXTS */

        function getByFilterPublicRelationsTexts (query) {
            return $http.get(API_BASE + '/physicalfairs/publicrelationstexts',{params:query});
        }

        function downloadPublicRelationsTextsCSV (query) {
            return $http.get(API_BASE + '/physicalfairs/publicrelationstexts/csv',{params:query});
        }

        /* WELCOMER LETTERS */
        function getByFilterExpoLocation(query) {
            return $http.get(API_BASE + '/physicalfairs/getexpolocation',{params:query});
        }

        function downloadWelcomeLetter(query)
        {
            return $http.get(API_BASE + '/physicalfairs/welcomeletter/pdf',{params:query});
        }

        /* ACCEPTED INVOICES */

        function getRepresentativesByExpo(query)
        {
            return $http.get(API_BASE + '/physicalfairs/getRepresentatives',{params:query});
        }

        function getAcceptedInvoices(query)
        {
            return $http.get(API_BASE + '/physicalfairs/getAcceptedInvoices',{params:query});
        }

        /* FLIGHTS REQUESTS */

        function getFlightsRequests(query)
        {
            return $http.get(API_BASE + '/physicalfairs/getFlightsRequests',{params:query});
        }

        function getFlightsRequestsCSV(query)
        {
            return $http.get(API_BASE + '/physicalfairs/getFlightsRequests/csv',{params:query});
        }

        /* EMAIL EXHIBITORS SELECTION */
        function getEmailExhibitorsLocations(query)
        {
            return $http.get(API_BASE + '/physicalfairs/getEmailExhibitorsLocations',{params:query});
        }
        function getExhibitorsFromExpoLocationId(query)
        {
            return $http.get(API_BASE + '/physicalfairs/getExhibitorsFromExpoLocationId',{params:query});
        }
        function getExhibitorsFromExpoId(query)
        {
            return $http.get(API_BASE + '/physicalfairs/getExhibitorsFromExpoId',{params:query});
        }

        function getAllExhibitorsFromExpoLocationId(query)
        {
            return $http.get(API_BASE + '/physicalfairs/getAllExhibitorsFromExpoLocationId',{params:query});
        }

        function updateExhibitorsSelected(data)
        {
            return $http.post(API_BASE + '/physicalfairs/updateExhibitorsSelected', data)
                .then(function(response) {
                    return response.data;
                });
        }

        /* BOOTH TABLE BOOKED */

        function getByFilterBoothTableBooked (query)
        {
            return $http.get(API_BASE + '/physicalfairs/boothtablebooked',{params:query});
        }

        function getByFilterBoothTableBookedCSV (query)
        {
            return $http.get(API_BASE + '/physicalfairs/boothtablebooked/csv',{params:query});
        }

        /* PHYSICAL FAIRS STUDENT REGISTRATIONS DATA */

        function getByFilterStudentsRegistrations (query)
        {
            return $http.get(API_BASE + '/physicalfairs/students/registrations',{params:query});
        }

        function getExhibitorsRegistrationComparative (query)
        {
            return $http.get(API_BASE + '/physicalfairs/expositors/comparative',{params:query});
        }

        /* STUDENT PHONES */
        function getStudentsPhones (query)
        {
            return $http.get(API_BASE + '/physicalfairs/students/phones',{params:query});
        }

        function getStudentsPhonesCsv (query)
        {
            return $http.get(API_BASE + '/physicalfairs/students/phones/csv',{params:query});
        }

        /* STUDENT EMAILS */
        function getStudentsEmails (query)
        {
            return $http.get(API_BASE + '/physicalfairs/students/emails',{params:query});
        }

        function getStudentsEmailsCsv (query)
        {
            return $http.get(API_BASE + '/physicalfairs/students/emails/csv',{params:query});
        }

        /* NETWORKING COUNSELORS */
        function getNetworkingCounselors (query)
        {
            return $http.get(API_BASE + '/physicalfairs/networking-counselors',{params:query});
        }

        function getNetworkingCounselorsCsv (query)
        {
            return $http.get(API_BASE + '/physicalfairs/networking-counselors/csv',{params:query});
        }

        /* PRE REGISTRATIONS */

        function getByFilterPreRegistrations (query)
        {
            return $http.get(API_BASE + '/physicalfairs/preapproved',{params:query});
        }

        function getByFilterExpenses (query) {
            return $http.get(API_BASE + '/physicalfairs/expenses',{params:query});
        }

        function storeExpense(data) {
            return $http.post(API_BASE + '/physicalfairs/expenses', data)
                .then(function(response) {
                    return response.data;
                });
        }

        function updateExpense(id, data) {
            return $http.put(API_BASE + '/physicalfairs/' + id + '/expenses', data)
                .then(function(response) {
                    return response.data;
                });
        }

        function getExpense(id) {
            return $http.get(API_BASE + '/physicalfairs/' + id + '/expenses', {});
        }

        function destroyExpense(id) {
            return $http.delete(API_BASE + '/physicalfairs/' + id + '/expenses', {});
        }

        function getSponsors(query) {
            return $http.get(API_BASE + '/physicalfairs/sponsorships', {params: query});
        }

        function getBoothTypes(query) {
            return $http.get(API_BASE + '/physicalfairs/boothtypes', {params: query});
        }

        function getSideEvents(query) {
            return $http.get(API_BASE + '/physicalfairs/sideevents', {params: query});
        }

        /* STUDENTS ENROLLED */

        function getStudentsEnrolled(query) {
            return $http.get(API_BASE + '/physicalfairs/studentsenrolled', {params: query});
        }

        function getStudentsEnrolledCsv(query) {
            return $http.get(API_BASE + '/physicalfairs/studentsenrolled/csv', {params: query});
        }

        function sendInviteToStudentsEnrolled (data) {
            return $http.post(API_BASE + '/physicalfairs/studentsenrolled/invite', data);
        }
        
        /* ROADSHOW SURVEYS */
        function getSurveys(query) {
            return $http.get(API_BASE + '/survey/list', {params: query});
        }

        function getSurveyQuestions(query) {
            return $http.get(API_BASE + '/survey/question/list', {params: query});
        }

        function copySurvey(fields) {
            return $http.post(API_BASE + '/survey/copy', {params: fields});
        }

        function downloadCSVExpo(fields) {
            return $http.get(API_BASE + '/survey/download_csv/expo', {params: fields});
        }

        function downloadCSVVirtualFair(fields) {
            return $http.get(API_BASE + '/survey/download_csv/virtual-fair', {params: fields});
        }
        
        function getCommunitiesCollege(id) {
            return $http.get(API_BASE + '/expos/communities/' + id, {});
        }

        function leadsCSV(id, query) {
          return $http.get(API_BASE + `/physicalfairs/leads/${id}/csv`, {params: query});
        }

        function getTranslators(query) {
            return $http.get(API_BASE + '/physicalfairs/translators', {params: query});
        }

        function getLeadsBooth(query) {
            return $http.get(API_BASE + "/physicalfairs/leads-booth", {
              params: query,
            });
        }
      
        function getLeadsBoothCsv(query) {
            return $http.get(API_BASE + "/physicalfairs/leads-booth/csv", {
                params: query,
            });
        }

        function sendEmailTest(data) {
            return $http.post(API_BASE + "/physicalfairs/settings/email-test", data);
        }
        function getPrograms(query) {
            return $http.get(API_BASE + '/physicalfairs/programs/list', {params: query});
        }

        function getPrizes(query){
            return $http.get(API_BASE + "/physicalfairs/prizes/list",{params: query});
        }

        function getReferrals(query){
            return $http.get(API_BASE + "/physicalfairs/referrals/list",{params: query});
        }

        function getWinners(query){
            return $http.get(API_BASE + "/physicalfairs/prizes/winners/list",{params: query});
        }

        function generateWinners(query){
            return $http.get(API_BASE + "/physicalfairs/prizes/winners/generate",{params: query});
        }
        function saveWinners(payload){
            return $http.post(API_BASE + "/physicalfairs/prizes/winners", payload);
        }
    }
})();